import EmblaCarousel from 'embla-carousel';
import { addDotBtnsAndClickHandlers } from './embla-dots';

class EmblaSlider extends HTMLElement {
  constructor() {
    super();

    this.emblaApi = null;

    this.options = {
      loop: false,
      slidesToScroll: 1,
      align: 'start',
      dragFree: false,
    };
  }

  connectedCallback() {
    const viewportNode = this.querySelector('.embla__viewport');
    const isDragFree = this.getAttribute('data-drag-free') === 'true';
    const isLoop = this.getAttribute('data-loop') === 'true';
    const showDots = this.getAttribute('data-show-dots') === 'true';
    const showProgressBar = this.getAttribute('data-show-progress-bar') === 'true';
    const showArrows = this.getAttribute('data-show-arrows') === 'true';
    const isDisableSwipe = this.getAttribute('data-disable-swipe') === 'true';
    const dotsNode = this.querySelector('.embla__dots');
    const prevBtnNode = this.querySelector('.embla__button--prev');
    const nextBtnNode = this.querySelector('.embla__button--next');
    console.log('🚀 ~ embla-slider.js:29 ~ EmblaSlider ~ connectedCallback ~ nextBtnNode:', this);
    console.log('🚀 ~ embla-slider.js:29 ~ EmblaSlider ~ connectedCallback ~ nextBtnNode:', nextBtnNode);
    const progressBarNode = this.querySelector('[data-embla-progress-bar]');

    this.options.loop = isLoop;
    this.options.dragFree = !isDragFree;

    // Disable touch and mouse interactions when swipe is disabled
    if (isDisableSwipe) {
      this.options.dragFree = false;
      this.options.containScroll = 'trimSnaps';
      this.options.skipSnaps = false;
    }

    this.emblaApi = EmblaCarousel(viewportNode, this.options);

    // Disable touch and mouse events if swipe is disabled
    if (isDisableSwipe) {
      this.emblaApi.rootNode().style.pointerEvents = 'none';
      this.emblaApi.rootNode().style.userSelect = 'none';
      this.emblaApi.rootNode().style.touchAction = 'none';
    }

    if (showArrows) {
      if (!prevBtnNode || !nextBtnNode) {
        console.warn(
          'Embla arrows enabled, but buttons not found inside embla-slider.'
        );
      }

      if (prevBtnNode) {
        prevBtnNode.addEventListener('click', () => this.emblaApi.scrollPrev());
      }

      if (nextBtnNode) {
        nextBtnNode.addEventListener('click', () => {
          console.log('🚀 ~ embla-slider.js:64 ~ nextBtnNode.addEventListener ~ nextBtnNode:', this,this.emblaApi);
          this.emblaApi.scrollNext()
        });
      }
    }

    if (showDots && dotsNode) {
      addDotBtnsAndClickHandlers(this.emblaApi, dotsNode);
    }

    if (showProgressBar && progressBarNode) {
      const updateProgressBar = () => {
        const progress = Math.max(0, Math.min(1, this.emblaApi.scrollProgress()));

        progressBarNode.style.width = `${progress * 100}%`;
      };

      this.emblaApi.on('scroll', updateProgressBar);
      this.emblaApi.on('reInit', updateProgressBar);

      updateProgressBar();
    }
  }

  disconnectedCallback() {
    console.log('Custom element removed from page.');
    this.emblaApi.destroy();
  }

  connectedMoveCallback() {
    console.log('Custom element moved with moveBefore()');
    this.emblaApi.destroy();
  }

  adoptedCallback() {
    console.log('Custom element moved to new page.');
    this.emblaApi.destroy();
  }

  attributeChangedCallback(name) {
    console.log(`Attribute ${name} has changed.`);
  }
}

if (!customElements.get('embla-slider')) {
  customElements.define('embla-slider', EmblaSlider);
}
